module.exports = __webpack_public_path__ + "media/images/favicons_staging/android-chrome-192x192-6d7236f600affd0b52aba1807930e6a0.png";